import React from 'react'
import { Link } from '@reach/router'
import { ROUTES } from '../../routes'

const UserNotFoundView = () => {
  return (
    <div className="min-h-full pt-16 pb-12 flex flex-col bg-white">
      <main className="flex-grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-16">
          <div className="text-center">
            <p className="text-sm font-semibold text-tertiary-default uppercase tracking-wide">
              404 error
            </p>
            <h1 className="mt-2 text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
              Page not found.
            </h1>
            <p className="mt-2 text-base text-gray-500">
              Sorry, we couldn’t find the page you’re looking for.
            </p>
            <div className="mt-6">
              <Link to={ROUTES.USER.HOME}>
                <span className="text-base font-medium text-tertiary-default hover:text-indigo-500">
                  Go back home<span aria-hidden="true"> &rarr;</span>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default UserNotFoundView
